import request from '@utils/request'

export function fetchAssets(params) {
  return request({
    url: `/admin/asset`,
    params,
  })
}

export function fetchAsset(seq) {
  return request({
    url: `/admin/asset/${seq || 0}`,
    method: 'get',
  })
}

export function createAsset(data) {
  return request.post('/admin/asset', data)
}

export function updateAsset(data) {
  return request.put(`/admin/asset/${data.seq}`, data)
}

export function deleteAsset(seq) {
  return request.delete(`/admin/asset/${seq}`)
}

export function fetchSupportedAssetPlugins() {
  return request({
    url: `/admin/asset/plugin/support`,
  })
}

export function fetchAssetPlugins(params) {
  return request({
    url: `/admin/asset/plugin`,
    params,
  })
}

export function fetchAssetPlugin(seq) {
  return request({
    url: `/admin/asset/plugin/${seq || 0}`,
    method: 'get',
  })
}

export function createAssetPlugin(data) {
  return request.post('/admin/asset/plugin', data)
}

export function updateAssetPlugin(data) {
  return request.put(`/admin/asset/plugin/${data.seq}`, data)
}

export function fetchWithdrawFees(params) {
  return request({
    url: `/admin/asset/withdraw-fee`,
    params,
  })
}

export function fetchWithdrawFee(seq) {
  return request({
    url: `/admin/asset/withdraw-fee/${seq || 0}`,
    method: 'get',
  })
}

export function createWithdrawFee(data) {
  return request.post('/admin/asset/withdraw-fee', data)
}

export function updateWithdrawFee(data) {
  return request.put(`/admin/asset/withdraw-fee/${data.seq}`, data)
}

export function deleteWithdrawFee(seq) {
  return request.delete(`/admin/asset/withdraw-fee/${seq}`)
}
